import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ReportsService } from '../../data/reports.service';
import { QBTransaction } from '../../data/qb-transaction';
import { trackEntityById } from 'projects/core/src/public-api';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ProjectInfoComponent } from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import { SaleStat } from '../../data/sale-stat';
import { EstimateDialogComponent } from '../../../qb/view/estimate-dialog/estimate-dialog.component';
import { Project } from '../../../project-misc/data/project/project';
import { ProjectService } from '../../../project-misc/data/project/project.service';
import { environment } from 'projects/desktop/src/environments/environment';

@Component({
  selector: 'app-salesperson-transactions-dialog',
  templateUrl: './salesperson-transactions-dialog.component.html',
  styleUrls: ['./salesperson-transactions-dialog.component.scss'],
  providers: [DeviceDetectorService]
})
export class SalespersonTransactionsDialogComponent implements OnInit {
  userTransactions: QBTransaction[] = [];
  copyList: QBTransaction[] = [];

  sortMap = new Map();
  lastSortLabel: string;

  contentLoading: boolean;

  trackEntityById = trackEntityById;

  userId: number;
  userName: string;
  startDate: string;
  finishDate: string;

  totalInfo: SaleStat

  Estimate = true;
  Invoice = true;
  Payment = true;

  estimates: QBTransaction[] = [];
  invoices: QBTransaction[] = [];
  payments: QBTransaction[] = [];


  constructor(
    protected deviceDetectorService: DeviceDetectorService,
    protected dialog: MatDialog,
    protected projectService: ProjectService,
    protected reportsService: ReportsService,
    @Inject(MAT_DIALOG_DATA) private data: {
      userId: number,
      userName: string,
      startDate: string,
      finishDate: string,
      info: SaleStat,
      fromSchedule: boolean
    }) {
    this.userId = data.userId
    this.userName = data.userName
    this.startDate = data.startDate
    this.finishDate = data.finishDate

    this.totalInfo = data.info ? Object.assign({}, data.info) : new SaleStat()
  }


  ngOnInit(): void {
    this.userTransactions = [];
    this.copyList = [];

    this.nullifyMap();

    this.contentLoading = true;

    let getService = this.reportsService.getTransactionsForUser(this.data.startDate, this.data.finishDate, this.data.userId)
    if(this.data.fromSchedule) {
      getService = this.reportsService.getTransactionsForSchedule(this.data.startDate, this.data.finishDate)
    }

    getService.subscribe(transactions => {
      this.userTransactions = transactions;
      this.countTotals();

      this.contentLoading = false;
      this.copyList = [...this.userTransactions];

      this.estimates = this.copyList.filter(trans => trans.type === 'Estimate');
      this.invoices = this.copyList.filter(trans => trans.type === 'Invoice');
      this.payments = this.copyList.filter(trans => trans.type === 'Payment');

      this.sortByLabel('createTime');
    }, error => {
      this.contentLoading = false;
    })
  }

  countTotals() {
    this.totalInfo.totalAmt = 0;
    this.totalInfo.invoicedBalance = 0;
    this.totalInfo.paymentsReceived = 0;

    this.userTransactions.forEach(trans => {
      if(trans.type === 'Estimate') {
        this.totalInfo.totalAmt += trans.totalAmt
      } else if(trans.type === 'Invoice') {
        this.totalInfo.invoicedBalance += trans.totalAmt
      } else if(trans.type === 'Payment') {
        this.totalInfo.paymentsReceived += trans.totalAmt
      }
    })


  }

  nullifyMap() {
    this.sortMap.set('createTime', 0);
    this.sortMap.set('docNumber', 0);
    this.sortMap.set('dueDate', 0);
    this.sortMap.set('type', 0);
    this.sortMap.set('balance', 0);
    this.sortMap.set('totalAmt', 0);
    this.sortMap.set('jobName', 0);
    this.sortMap.set('txnStatus', 0);
  }

  countMap(param: string) {
    let num = this.sortMap.get(param);
    if(num === 1) {
      num++;
    } else if(num === 0) {
      this.nullifyMap();
      num++;
    } else if(num === 2) {
      num = 0;
    }

    this.sortMap.set(param, num);
  }

  sortByLabel(param: string) {
    if(!this.contentLoading) {
      this.lastSortLabel = param;

      this.countMap(param);
      let numm = 1;
      if(this.sortMap.get(param) === 2) numm = -1;
      if(this.sortMap.get(param) === 0) {
        this.userTransactions = this.copyList.filter(trans => {
          if(trans.type === 'Estimate') {
            return this.Estimate
          }
          if(trans.type === 'Invoice') {
            return this.Invoice
          }
          if(trans.type === 'Payment') {
            return this.Payment
          }
        })
        return
      }

      this.userTransactions.sort((a, b) => {
        if(param === 'createTime') {
          return (b.txnDate.getTime() - a.txnDate.getTime()) * numm;
        }
        if(param === 'txnStatus' || param === 'type') {
          let aString = a[param]
          let bString = b[param]

          if(a[param] === '') {
            aString = 'z'
          }
          if(b[param] === '') {
            bString = 'z'
          }

          if(aString < bString) {
            return -1 * numm;
          }
          if(aString > bString) {
            return 1 * numm;
          }
          return 0;
        }

        if(param === 'jobName') {
          const aString = a.project ? a.project.name : 'z'
          const bString = b.project ? b.project.name : 'z'

          if(aString < bString) {
            return -1 * numm;
          }
          if(aString > bString) {
            return 1 * numm;
          }
          return 0;
        }

        return (b[param] - a[param]) * numm
      })
    }
  }

  openProject(projectId: number) {

    let projectWindow = ProjectWindowComponent as any;

    let panelClass = 'project-window-dialog'

    if(this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet()) {
      projectWindow = ProjectInfoComponent
      panelClass = 'project-info-dialog'
    }

    const dialogRef = this.dialog.open(projectWindow, {
      data: {
        projectNumber: projectId
      },
      panelClass
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openBilling(project: Project) {
    if(project && project.id) {
      const dialogRef = this.dialog.open(EstimateDialogComponent, {
        data: project.id,
        panelClass: 'estimates-modal-dialog',
        disableClose: false
      });

      dialogRef.afterClosed().subscribe(result => {

        // if (result === 'Success!') {
        // 	this.openSuccessSnackBar('Success!')
        // }
      });
    }
  }

  toggleType(type: string) {
    this[type] = !this[type];

    if(!this[type]) {
      this.userTransactions = this.userTransactions.filter(trans => {
        if(trans.type === 'Estimate') {
          return this.Estimate
        }
        if(trans.type === 'Invoice') {
          return this.Invoice
        }
        if(trans.type === 'Payment') {
          return this.Payment
        }
      })
    } else {

      this.userTransactions = this.userTransactions.concat(this[type.toLowerCase() + 's'])

      this.sortByLabel(this.lastSortLabel)
      this.sortByLabel(this.lastSortLabel)
      this.sortByLabel(this.lastSortLabel)
    }

  }

  openInQb(sale: QBTransaction) {
    let baseLink = `https://app.qbo.intuit.com/app`;

    if(environment.dev) {
      baseLink = `https://app.sandbox.qbo.intuit.com/app`
    }

    window.open(`${baseLink}/${sale.type.toLowerCase()}?txnId=${sale.qbId}`, '_blank');
  }
}
